// extracted by mini-css-extract-plugin
module.exports = {"root":"ChangeViewButton_root__bBb1X","active":"ChangeViewButton_active__3ZCll"};